import { render, staticRenderFns } from "./AddCustomAttribute.vue?vue&type=template&id=027b38da&scoped=true"
import script from "./AddCustomAttribute.vue?vue&type=script&lang=js"
export * from "./AddCustomAttribute.vue?vue&type=script&lang=js"
import style0 from "./AddCustomAttribute.vue?vue&type=style&index=0&id=027b38da&prod&lang=scss"
import style1 from "./AddCustomAttribute.vue?vue&type=style&index=1&id=027b38da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027b38da",
  null
  
)

export default component.exports